import { BaseMapper } from '@ps/utils';
import { ReportPreferenceDto } from '../dtos/report-preference.dto';
import { ReportPreference } from '@ps/user-settings-models';

export class ReportPreferenceMapper extends BaseMapper<
  ReportPreferenceDto,
  ReportPreference
> {
  public fromDto(dto: ReportPreferenceDto): ReportPreference {
    return {
      id: dto._id,
      column: dto.column,
      selected: dto.is_selected,
      order: dto.order,
    };
  }
}
